import { redirect } from '@tanstack/react-router';

import { useUserStore } from '~/store/userStore';

function useUser() {
    const user = useUserStore.use.user();
    if (user == null) {
        throw redirect({ to: '/login' });
    }
    return user;
}

export default useUser;
